// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "desktop_NewBuildingSearchRoute" + "_" + "42c5a4d95fe4d814972e" + ".css";
};